import { defineFcm } from '../shared/factory';

export const FCM_PSF_REASON_FOR_SIGNING = defineFcm('psf_reason_for_signing').asBoolean().withDefault(false).toConfig({
	owner: 'TBD',
	scope: 'corgi-front-end',
	context: 'petition page',
	description: 'Indicates whether the reason for signing should be stored in the sessionStorage (non-guests only)',
	import: false,
});
